import { Option } from 'lib/types';
import { PrimaryActionType } from './models/ContentModule';

export const PRIMARY_ACTION_ITEMS: { label: string; value: PrimaryActionType }[] = [
    {
        value: 'CHECKIN',
        label: 'Check-In'
    },
    {
        value: 'PREORDER',
        label: 'Preorder'
    },
    {
        value: 'TABLE_ORDER',
        label: 'Order to Table'
    },
    {
        value: 'PAY_AT_TABLE',
        label: 'Pay at Table'
    },
    {
        value: 'TABS',
        label: 'Tab'
    },
    {
        value: 'VOUCHER',
        label: 'Voucher'
    },
    {
        value: 'REFERRALS',
        label: 'Referrals'
    },
    {
        value: 'BARCODE',
        label: 'Barcode'
    },
    {
        value: 'USER_DETAILS',
        label: 'User Details'
    },
    {
        value: 'USER_PREFERENCES',
        label: 'User Preferences'
    },
    {
        value: 'BOOK_TABLE',
        label: 'Book a Table'
    },
    {
        value: 'BOOK_ROOM',
        label: 'Book a Room'
    },
    {
        value: 'BROWSER',
        label: 'Browser'
    },
    {
        value: 'USER_ORDERS',
        label: 'User Orders'
    },
    {
        value: 'DINE_IN',
        label: 'Dine In'
    }
];

export const PRIMARY_ACTION_ITEMS_FULL: { label: string; value: PrimaryActionType }[] = [
    ...PRIMARY_ACTION_ITEMS,
    {
        value: 'DELIVERY',
        label: 'Delivery'
    }
];

export function getPrimaryActionItemsOptions({ deliveryEnabled }: { deliveryEnabled: boolean }) {
    const options: Option[] = [...PRIMARY_ACTION_ITEMS];
    if (deliveryEnabled) {
        options.push({
            value: 'DELIVERY',
            label: 'Delivery'
        });
    }
    return options;
}

export const PRESET_ACTION_ITEMS = [
    {
        value: 'BROWSER',
        label: 'Browser',
        description: 'Add a link from your app to your webpage'
    },
    {
        value: 'NATIVE',
        label: 'Native',
        description: 'Create a fully customisable marketing item for your app'
    },
    {
        value: 'LOCATION',
        label: 'Location',
        description: 'Add a link that takes a user to the selected location details'
    },
    {
        value: 'LOCATIONS',
        label: 'Locations List',
        description: 'Add a link which allows users to view all your locations and their details'
    },
    {
        value: 'START_ORDER',
        label: 'Start Order',
        description: 'Add a link which deep links a user to a menu or product'
    },
    {
        value: 'PREORDER',
        label: 'Preorder',
        description: 'Add a link which allows users to preorder at a location'
    },
    {
        value: 'TABLE_ORDER',
        label: 'Table Order',
        description: 'Add a link which allows users to order to their table'
    },
    {
        value: 'PAY_AT_TABLE',
        label: 'Pay at Table',
        description: 'Add a link which allows users to fetch their bill and pay'
    },
    {
        value: 'VOUCHER',
        label: 'Vouchers',
        description: 'Add a link which allows users to enter a voucher code'
    },
    {
        value: 'REFERRALS',
        label: 'Referrals',
        description: 'Add a link that allows users to share a code with a friend'
    },
    {
        value: 'USER_DETAILS',
        label: 'User Details',
        description: 'Add a link that directs the user to their details within the app'
    },
    {
        value: 'USER_PREFERENCES',
        label: 'User Preferences',
        description: 'Add a link that directs the user to their marketing and tipping preferences'
    },
    {
        value: 'AWARDS',
        label: 'Awards',
        description: 'Add a link that displays all of a user’s awards on a single screen'
    },
    {
        value: 'CHECKIN',
        label: 'Checkin',
        description:
            'Add a button which allows users to checkin to their closest location to see location specific content'
    },
    {
        value: 'BARCODE',
        label: 'Barcode',
        description: 'Display a barcode or QR code for offline checkin'
    },
    {
        value: 'USER_ORDERS',
        label: 'User Orders',
        description: 'Add a link that directs the user to their order and action history in app'
    },
    {
        value: 'DINE_IN',
        label: 'Dine In',
        description: 'Add a link which allows users to order and dine in at a location'
    },
    {
        value: 'VIEW_SUBSCRIPTION_SCHEME',
        label: 'View Subscription Scheme',
        description: 'Add a link that lets users sign up for a subscription to earn rewards'
    }
];

export function getPresetActionItemsOptions({ deliveryEnabled }: { deliveryEnabled: boolean }) {
    const options: Option[] = [...PRESET_ACTION_ITEMS];
    if (deliveryEnabled) {
        options.push({
            value: 'DELIVERY',
            label: 'Delivery',
            description: 'Add a link which allows users to order which is delivered to an address'
        });
    }
    return options;
}
